import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { translate } from 'parking-react-common'

import { forms, auth } from '../redux'

import EmailPasswordChangeForm from '../components/EmailPasswordChangeForm'
import Panel from '../components/Panel'
import { Column } from '../components/Grid'

const EmailPasswordChangeContainer = ({ isLoading, t }) => (
    <Column span={ 8 }>
        <Panel title={ t('Change Password') } isLoading={ isLoading }>
            <EmailPasswordChangeForm />
        </Panel>
    </Column>
)

EmailPasswordChangeContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired
}

function mapStateToProps(state) {
    return {
        isLoading                : forms.isSubmitting(forms.changePassword.id)(state),
        pendingVerificationPhone : auth.getPendingVerificationPhone(state)
    }
}

export default translate()(connect(mapStateToProps)(EmailPasswordChangeContainer))
